module.exports = __webpack_public_path__ + "img/Fb-UIA-tw.3954c084.png";